import { TableCols } from '../interfaces/static-data';
import { PAYLOAD_FORMATS } from './data-ingestion-payload-format.const';
import { DATA_INGESTION_SERVICE_NAMES } from './data-ingestion-service-names.const';

export const DATA_INGESTION_CONFIG: TableCols[] = [
  {
    key: 'rank',
    displayValue: 'Rank',
  },
  {
    key: 'service',
    displayValue: 'Service',
    type: 'select',
    items: DATA_INGESTION_SERVICE_NAMES,
  },
  {
    key: 'payloadFormat',
    displayValue: 'Payload Format',
    type: 'select',
    items: PAYLOAD_FORMATS,
  },
  {
    key: 'evaluatePath',
    displayValue: 'Evaluate Path',
  },
  {
    key: 'valueToMatch',
    displayValue: 'Value To Match',
  },
  {
    key: 'ingestionIntegrator',
    displayValue: 'Ingestion Integrator',
  },
];
